import { FormattedMessage } from 'react-intl';

// Since Intl.PluralRules isn't working on IE 11 (neither is the polyfill <.<) we have to get the pluralized strings manually.

export const getPluralization = (singular: string, plural: string, count: number) => {
    return count === 1 ? <FormattedMessage id={singular} /> : <FormattedMessage id={plural} />;
};
